import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../../../constants/common'
import { useContentOverflow } from '../../../../../../../hooks'
import { FloatingTooltip } from '../../../../../../Floating'
import Text from '../../../../../../Text'
import { getApplicantDocumentTypeLabel } from '../../ApplicantDocumentChecklist.utils'

import * as styles from './ApplicantDocumentChecklistTypeCell.module.css'

function ApplicantDocumentChecklistTypeCell({ row }) {
  const { t } = useTranslation()

  const { overflow, setContentOverflowRef } = useContentOverflow()

  const typeLabel = getApplicantDocumentTypeLabel({ row, t })

  return (
    <FloatingTooltip
      content={typeLabel}
      disabled={!overflow}
      placement={FLOATING_ELEMENT_PLACEMENT.top}
    >
      <Text
        className={styles.ApplicantDocumentChecklistTypeCell}
        ref={setContentOverflowRef}
      >
        {typeLabel}
      </Text>
    </FloatingTooltip>
  )
}

export default ApplicantDocumentChecklistTypeCell
